// src/components/common/PageViewTracker.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/analytics';

export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Whenever the location (route) changes, call trackPageView
    trackPageView(location.pathname, document.title);
  }, [location]);

  return null; // This component doesn't render anything
}
